export default __webpack_public_path__ + "static/40u40-7b308ca3bdbf2f962f88578f63c838f4.png";